import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import ClickOutside from '../ClickOutside';

const DropdownNotification = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifying, setNotifying] = useState(true);

  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative">
      <button
        type="button"
        aria-label="Thông báo"
        aria-expanded={dropdownOpen}
        onClick={() => {
          setNotifying(false);
          setDropdownOpen(!dropdownOpen);
        }}
        className="adm-icon-btn"
      >
        <Bell size={20} aria-hidden="true" />
        {notifying && <span className="adm-icon-btn__dot" aria-hidden="true" />}
      </button>

      {dropdownOpen && (
        <div className="adm-popover" style={{ width: 320 }}>
          <div className="adm-popover__title">Thông báo</div>
          {/* QA S-35: bỏ 4 mục Lorem ipsum mẫu (template TailAdmin) — hiển thị empty state cho tới khi có nguồn thông báo thật. */}
          <div className="adm-popover__empty">Chưa có thông báo mới</div>
        </div>
      )}
    </ClickOutside>
  );
};

export default DropdownNotification;
